var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame38(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 531,
    height: 459,
    viewBox: "0 0 531 459",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410.217 166.629C467.296 119.882 542.968 195.554 496.221 252.633C475.363 278.102 475.363 314.748 496.221 340.217C542.968 397.296 467.297 472.968 410.217 426.221C384.748 405.363 348.102 405.363 322.633 426.221C265.554 472.968 189.882 397.297 236.629 340.217C257.487 314.748 257.487 278.102 236.629 252.633C189.882 195.554 265.554 119.882 322.633 166.629C348.102 187.487 384.748 187.487 410.217 166.629Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M381.367 143.392C438.447 96.6445 514.119 172.316 467.371 229.396C446.513 254.865 446.513 291.511 467.371 316.979C514.119 374.059 438.447 449.731 381.367 402.984C355.898 382.125 319.253 382.125 293.784 402.984C236.704 449.731 161.032 374.059 207.779 316.979C228.638 291.511 228.638 254.865 207.779 229.396C161.032 172.316 236.704 96.6444 293.784 143.392C319.253 164.25 355.898 164.25 381.367 143.392Z",
    fill: "#EC6A36",
    stroke: "black",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.399 80.0331C243.121 29.3223 169.926 29.3223 140.649 80.0332L58.3044 222.657C29.0265 273.368 65.624 336.757 124.18 336.757H288.868C347.424 336.757 384.021 273.368 354.743 222.657L272.399 80.0331ZM231.014 158.961C218.721 138.24 187.989 138.24 175.697 158.961L141.124 217.238C128.831 237.958 144.197 263.859 168.782 263.859H237.928C262.514 263.859 277.88 237.958 265.587 217.238L231.014 158.961Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.399 55.0331C213.121 4.32225 139.926 4.32232 110.649 55.0332L28.3044 197.657C-0.973503 248.368 35.624 311.757 94.1798 311.757H258.868C317.424 311.757 354.021 248.368 324.743 197.657L242.399 55.0331ZM201.014 133.961C188.721 113.24 157.989 113.24 145.697 133.961L111.124 192.238C98.831 212.958 114.197 238.859 138.782 238.859H207.928C232.514 238.859 247.88 212.958 235.587 192.238L201.014 133.961Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame38);
export default __webpack_public_path__ + "static/media/Frame 38.3d4b9f220e9883cd30636f2814c22f3e.svg";
export { ForwardRef as ReactComponent };